<template>
  <div>
    <h1>NotFoundScreen</h1>
  </div>
</template>

<script>
  export default {
    name: 'NotFoundScreen'
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/NotFound/components/NotFoundScreen.vue